'use client';

import LegalDocument from '@/components/LegalDocument';

export default function LegalNotice() {
  return <LegalDocument documentPath="/legal/impressum_en.md" />;
}